<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>IMPORT_TIRE_POLICIES</h4>
  <button type="button" class="close" aria-label="Close" (click)="crossClick()" [disabled]="isImporting">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <lib-gung-input-file
    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    [multiple]="false"
    (onFileSelect)="onFileSelect($event)"
    [enableDragDrop]="true"
  ></lib-gung-input-file>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger" (click)="crossClick()" [disabled]="isImporting" translate>
    CLOSE
  </button>

  <button type="button" class="btn btn-primary ml-auto" (click)="import($event)" [disabled]="isImporting || !selectedFile" translate>
    IMPORT
  </button>
</div>
